import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { fetchDat } from '../../utils';
import * as actionTypes from '../../store/actionTypes';
import { usePoll } from '../../hooks/usePoll';
import CommonMenu from '../../components/commonMenu/commonMenu';
import TokenTable from '../../components/Tables/TokenTable/token.table';
import { useTokenListing, ListingFooter } from '../../hooks/useTokenListing';
import MarketStats from '../../components/MarketStats/MarketStats';

// DBT (Digital Basket Token) listing.
//
// Pagination was broken two ways: the API ignored perPage and always sent
// every DBT on page 1 (36 today), while the page's own "<" / ">" buttons
// stepped a server page counter - so ">" fetched an empty page 2, "<" could
// go to page 0, and the "showing 0-10/10" label was computed from the wrong
// totals. The search box also only searched whatever page was loaded.
//
// The whole DBT list is small, so it's now fetched in one request and paged
// and searched here, with the same MUI pagination as the EquiTrack listing.
const FETCH_ALL = 500; // backend clamps perPage; one request covers every DBT

const DatTable = () => {
  const dispatch = useDispatch();
  const { dat, PecuPrice } = useSelector(
    (state) => ({ dat: state.dat, PecuPrice: state.PecuPrice }),
    shallowEqual
  );

  const [searchToken, setSearchToken] = useState('');
  const [blinkUpList, setBlinkUpList] = useState([]);
  const [blinkDownList, setBlinkDownList] = useState([]);
  const prevPrices = useRef({});

  usePoll(() => fetchDat(dispatch, actionTypes.FETCH_DAT, 1, FETCH_ALL), 5000, []);

  const allTokens = useMemo(
    () => (Array.isArray(dat?.tokens) ? dat.tokens : []),
    [dat]
  );

  // Search + pagination over every DBT (shared with the other listings).
  const listing = useTokenListing(allTokens, searchToken);

  // Up/down row flash on price changes.
  useEffect(() => {
    const up = [];
    const down = [];
    const next = {};
    for (const t of allTokens) {
      const price = Number(t.currentPrice);
      next[t.identitySymbol] = price;
      const prev = prevPrices.current[t.identitySymbol];
      if (prev !== undefined && prev !== price) {
        (price > prev ? up : down).push(t.identitySymbol);
      }
    }
    prevPrices.current = next;
    if (up.length || down.length) {
      setBlinkUpList(up);
      setBlinkDownList(down);
      const timer = setTimeout(() => {
        setBlinkUpList([]);
        setBlinkDownList([]);
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [allTokens]);

  const loaded = Array.isArray(dat?.tokens);

  return (
    <div
      className="screen"
      style={{
        zIndex: '100',
        position: 'sticky',
        width: '100%',
        marginBottom: '1rem'
      }}
    >

      <div style={{ width: '95%', minWidth: '340px' }} className="res-token">

        <MarketStats />
        <CommonMenu label={'DBTs'} setSearch={setSearchToken} />
        <TokenTable
          loading={!loaded}
          token={listing.pageRows}
          blinkUpList={blinkUpList}
          blinkDownList={blinkDownList}
          href={'dbt'}
          PecuPrice={PecuPrice}
          swappable={true}
          showPecu={false}
        />
        <ListingFooter listing={listing} loaded={loaded} noun="DBTs" />
      </div>
    </div>
  );
};

export default React.memo(DatTable);
